"use client";

import { ComponentProps } from "react";
import Link from "next/link";
import { usePerformance } from "@/contexts/performance-context";
import { MouseEvent } from "react";

const BaseLink = (props: ComponentProps<typeof Link>) => {
  const { children, href, onClick, ...rest } = props;
  const { setBenchmarkTime } = usePerformance();

  const isInternal = !(
    href.toString().startsWith("http") ||
    href.toString().startsWith("mailto:") ||
    href.toString().startsWith("tel:") ||
    href.toString().startsWith("#")
  );

  const handleClick = (
    e: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>,
  ) => {
    setBenchmarkTime(`Before navigating to ${href.toString()}`);

    onClick?.(e);
  };

  if (isInternal) {
    return (
      <Link
        {...rest}
        href={`${process.env.NEXT_PUBLIC_BASE_PATH ?? ""}${!href.toString().startsWith("/") ? "/" : ""}${href.toString()}`}
        onClick={handleClick}
      >
        {children}
      </Link>
    );
  }

  return (
    <a {...rest} href={href.toString()} onClick={handleClick}>
      {children}
    </a>
  );
};

export default BaseLink;
